import styled from 'styled-components';

export const Input = styled.input`
  color: #e6eaec;
  box-sizing: border-box;
  font-size: 14px;
  padding: 9px 11px;
  background-color: #1a2429;
  height: 40px;
  display: ${(props) => {
    if (props.mergedLeftInput || props.mergedRightInput) return 'inline-block';
  }};
  border: solid 1px #3d4952;
  border-right: ${(props) => {
    if (props.mergedLeftInput) return 0;
  }};
  border-radius: ${(props) => {
    if (props.mergedLeftInput) return '8px 0 0 8px';
    else if (props.mergedRightInput) return '0 8px 8px 0';
    else return '8px';
  }};
`;

export const InputBox = styled.div`
  display: inline-block;
  position: relative;
`;

export const DateInputBox = styled.div`
  position: relative;
  width: 175px;
  cursor: pointer;
`;

export const DateInput = styled(Input).attrs({
  disabled: 'disabled',
})`
  width: 175px;
  cursor: pointer;
  pointer-events: none;
  padding-right: 34px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2347b972' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3.5' y='5' width='17' height='15' rx='2'/%3E%3Cpath d='M3.5 9.5h17M8 3.2v3.6M16 3.2v3.6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
`;

export const CalendarBox = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 6px;
  z-index: 1000;
`;
